import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(theme => ({
  coachProfileCardsContainer: {
    margin: '0 1rem',
  },
  qrCodeCardContainer: {
    borderColor: '#ccc',
  },
  containerQRCode: {
    padding: '16px 0 20px 0',
  },
  qrCode: {
    border: '1px solid #AB9157',
    borderRadius: '4px',
    padding: '10px',
  },
  analyticsCardContainer: {
    [theme.breakpoints.down('sm')]: {
      margin: '0 1rem 1rem',
    },
    [theme.breakpoints.up('sm')]: {
      margin: '1rem ',
    },
    [theme.breakpoints.up('lg')]: {
      margin: '4.125rem 0 .125rem',
    },
    borderRadius: '4px',
    padding: '2rem',
    border: '1px solid #ccc',
  },
}))
